import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { OrdersWithPayment } from 'src/app/models/order';
import { OrderService } from 'src/app/order.service';
import { EarnedReward, earnedRewardSummary } from 'src/app/models/earned-reward';

@Component({
  selector: 'app-earned-reward-banner',
  templateUrl: './earned-reward-banner.component.html',
  styleUrls: ['./earned-reward-banner.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EarnedRewardBannerComponent implements OnInit {

  @Input() orderWithPayment: OrdersWithPayment;
  @Output() refresh = new EventEmitter<boolean>();

  rewards: EarnedReward[] = [];
  isApplying = false;

  constructor(
    private orderService: OrderService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const phoneNumber = localStorage.getItem('phoneNumber');
    const userHash = this.orderWithPayment && this.orderWithPayment.bot_order
      && this.orderWithPayment.bot_order.encoded_id;
    const storeId = this.orderWithPayment && this.orderWithPayment.bot_order
      && this.orderWithPayment.bot_order.store;
    if (!phoneNumber || !userHash || !storeId) {
      return;
    }

    this.orderService.getMyRewards(String(storeId), userHash).subscribe({
      next: (data) => {
        const appliedCode = this.orderWithPayment.bot_order.promo_code;
        this.rewards = ((data && data.active) || []).filter(r =>
          r.status === 'ACTIVE' &&
          r.reward_code !== appliedCode);
        this.cdr.markForCheck();
      },
      error: () => { }
    });
  }

  get totalCredit(): number {
    return this.rewards
      .filter(r => r.reward_kind === 'GIFT_CARD_CREDIT')
      .reduce((sum, r) => sum + (+(r.credit_balance != null ? r.credit_balance : r.amount) || 0), 0);
  }

  get nonCreditRewards(): EarnedReward[] {
    return this.rewards.filter(r => r.reward_kind !== 'GIFT_CARD_CREDIT');
  }

  getRewardSummary(reward: EarnedReward) {
    return earnedRewardSummary(reward);
  }

  minSpendMet(reward: EarnedReward): boolean {
    if (!reward || !(+reward.min_next_order_spend > 0)) {
      return true;
    }
    const subTotal = this.orderWithPayment && this.orderWithPayment.payment
      ? +this.orderWithPayment.payment.sub_total : 0;
    return subTotal >= +reward.min_next_order_spend;
  }

  minSpendGap(reward: EarnedReward): number {
    const subTotal = this.orderWithPayment && this.orderWithPayment.payment
      ? +this.orderWithPayment.payment.sub_total : 0;
    return Math.max(0, +reward.min_next_order_spend - subTotal);
  }

  applyReward(reward: EarnedReward) {
    if (this.isApplying || !this.orderWithPayment || !this.orderWithPayment.bot_order) return;
    this.isApplying = true;
    const orderHash = this.orderWithPayment.bot_order.order_hash;
    if (reward.reward_kind === 'FREE_ITEM' && reward.free_item_menu_item_id) {
      this.orderService.addItem(orderHash, reward.free_item_menu_item_id, '', 1).subscribe({
        next: () => this.applyCode(orderHash, reward),
        error: () => {
          this.isApplying = false;
          this.cdr.markForCheck();
        }
      });
    } else {
      this.applyCode(orderHash, reward);
    }
  }

  private applyCode(orderHash: string, reward: EarnedReward) {
    this.orderService.applyPromoCode(orderHash, reward.reward_code).subscribe({
      next: () => {
        this.isApplying = false;
        this.rewards = this.rewards.filter(r => r.id !== reward.id);
        this.refresh.emit(true);
        this.cdr.markForCheck();
      },
      error: () => {
        this.isApplying = false;
        this.cdr.markForCheck();
      }
    });
  }

}
